import React from "react";
import OrderTable from "../components/OrderTable";
import NotificationComponent from "../components/notifications";

const OrderDetails = () => {

    return (
        <div>
            <OrderTable />
            {/* <NotificationComponent /> */}
        </div>
    )
}

export default OrderDetails;